export const defaultCloMappingConfig = [
  {
    name: "clo_mapping_config",
    type: "List",
    value: [],
    docUrl: "https://applicate.atlassian.net/l/cp/90s18da0",
    description: "CLO mapping configuration for outlet type mappings",
    defaultValue: [],
    possibleVals: []
  }
];

export const CloMappingConfig = {
  columns: [
    { headerName: "Store", mappedValue: "newOutletType" },
    { headerName: "Channel", mappedValue: "channel" },
    { headerName: "Loyalty Type", mappedValue: "loyaltyType" },
    { headerName: "Outlet Type", mappedValue: "outletType" }
  ],
  Actions: [
    "Update",
    "Delete"
  ]
}; 